import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
//limitless imports
import SectionHeader from "../section-header/SectionHeader";
const BrandLearningTabHeader = ({
  content,
  leftSpaceContainer,
  extraHeaderStyle = ""
}) => {
  return /*#__PURE__*/React.createElement(Grid, {
    className: leftSpaceContainer
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    header: content.title,
    extraHeaderStyle: extraHeaderStyle
  }));
};
BrandLearningTabHeader.propTypes = {
  content: PropTypes.object.isRequired,
  leftSpaceContainer: PropTypes.string,
  extraHeaderStyle: PropTypes.string
};
export default BrandLearningTabHeader;